'use strict';

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');

const _element='body';
const _supportRedirectClass='support-redirect';

const _includes=(arr,val)=>arr.indexOf(val)!==-1;let

StateClassDirective=class StateClassDirective{
static get type(){
return'directive';
}

factory($rootScope,elementService,Analytics,userService,redirectionService,fatigueMeterTypeContentProviderService){
return{
restrict:'A',
link:()=>{
$rootScope.$on('$stateChangeSuccess',(event,toState,toParams,fromState,fromParams)=>{
const currentStateName='state-'+_.kebabCase(_.last(toState.name.split('.')));
const lastStateName='state-'+_.kebabCase(_.last(fromState.name.split('.')));

if(currentStateName==lastStateName){
return;
}

fastdom.measure(()=>{
const currentClasses=elementService.classList(_element);

const removeClass=className=>{
if(_includes(currentClasses,className)){
elementService.removeClass(_element,className);
}
};

const addClass=className=>{
if(!_includes(currentClasses,className)){
elementService.addClass(_element,className);
}
};

fastdom.mutate(()=>{
removeClass(lastStateName);
addClass(currentStateName);

if(redirectionService.helpCenterRedirectIsPending){
addClass(_supportRedirectClass);
}else{
removeClass(_supportRedirectClass);
}

const fatigueMeterType=fatigueMeterTypeContentProviderService.fatigueMeterType;

const isWFMAviation=fatigueMeterType===FatigueMeterType.WorkforceAviation;


const fatigueMeterTypeClass=`fatigue-meter-${isWFMAviation?'workforce':fatigueMeterType.value.toLowerCase()}`;

const validClasses=[fatigueMeterTypeClass];
if(isWFMAviation){
validClasses.push('fatigue-meter-workforce-aviation');
}

const fatigueMeterClasses=currentClasses.filter(c=>c.startsWith('fatigue-meter-'));
for(const className of fatigueMeterClasses){
if(validClasses.indexOf(className)===-1){
elementService.removeClass(_element,className);
}
}

for(const _class of validClasses){
addClass(_class);
}

Analytics.trackEvent('state','change',toState.name);
});
});
});
}};

}};


module.exports=StateClassDirective;
module.exports.prototype.factory.$inject=['$rootScope','elementService','Analytics','userService','redirectionService','fatigueMeterTypeContentProviderService'];
//# sourceMappingURL=stateClassDirective.js.map
